import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 mt-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="font-display font-black text-2xl text-white">
            EuroAsia Recruiting
            <span className="ml-2 text-xs font-mono-ui uppercase tracking-[0.2em] text-blue-400">
              Europe
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm text-slate-400 leading-relaxed">
            International IT, SAP, AI and Executive search across Germany,
            Netherlands, Romania, Poland, Bulgaria and Remote Europe. AI-powered
            matching, vetted candidates, GDPR-compliant.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">
            Locations
          </div>
          <ul className="mt-4 space-y-2 text-sm">
            {[
              ["germany", "Germany"],
              ["netherlands", "Netherlands"],
              ["romania", "Romania"],
              ["poland", "Poland"],
              ["bulgaria", "Bulgaria"],
              ["remote-europe", "Remote Europe"],
            ].map(([s, n]) => (
              <li key={s}>
                <Link
                  data-testid={`footer-location-${s}`}
                  to={`/locations/${s}`}
                  className="hover:text-white"
                >
                  {n}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">
            Services
          </div>
          <ul className="mt-4 space-y-2 text-sm">
            <li>IT Recruitment</li>
            <li>SAP Recruitment</li>
            <li>Executive Search</li>
            <li>Nearshore Engineers</li>
            <li>AI Engineers</li>
            <li>Remote Developers</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex flex-col md:flex-row justify-between gap-2">
          <div>© {new Date().getFullYear()} EuroAsia Recruiting. All rights reserved.</div>
          <div>GDPR compliant · ISO 27001 aligned · EU-based data processing</div>
        </div>
      </div>
    </footer>
  );
}
